{
  "topMenu": {
    "dihTitle": "Data Intelligence Hub",
    "dihSubTitle": "Extract value from data securely",
    "logout": "Log out",
    "dihPortal": "DIH Portal",
    "cofinityDataspace": "Dataspace Portal",
    "portal": "Portal"
  },
  "userLogoutAlert": {
    "title": "Are you sure you want to log out?",
    "back": "Back",
    "logout": "Log out"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "Home",
    "collapse": "Collapse sidebar",
    "help": "Help",
    "prepare": "Model Management",
    "model": "Data model",
    "mapping": "Data mapping",
    "converter": "Data converter",
    "provide": "Provide",
    "publishData": "Publish data",
    "assets": "Assets",
    "policyPublicationTemplate": "Policy publication template",
    "uploadHistory": "Asset upload history",
    "consume": "Consume",
    "searchDataOffers": "Search data offers",
    "negotiatedDataOffers": "Negotiated data offers",
    "downloadHistory": "Asset download history",
    "govern": "Govern",
    "myPolicies": "My policies",
    "createPolicies": "Create Policies",
    "policyTemplate": "Policy Templates",
    "manageAndConfig": "Configure",
    "connections": "Manage connectors",
    "jobs": "Process logs",
    "monitoring": "Monitor",
    "licences": "Licences",
    "contractDefinitions": "My contract definitions",
    "contractAgreements": "Contract agreements",
    "providedAgreements": "Provided contract agreements",
    "incomingAgreements": "Incoming data offers",
    "consumedAgreements": "Consumed contract agreements",
    "consumeAutomation": "Consume policy automation",
    "networkAnalytics": "Network analytics",
    "otherLogs": "Other logs",
    "digitalTwin": "Digital twin browser",
    "messagesBrowserInbound": "Inbound messages",
    "messagesBrowserOutbound": "Outbound messages",
    "applications": "Applications",
    "electronicControlUnit": "Electronic control unit",
    "pcfExchange": "PCF exchange (Jupiter)",
    "pcfExchangeV9": "PCF exchange (Saturn)",
    "pcfRequests": "PCF data requests",
    "pcfExchangeHistory": "PCF data exchange history",
    "pcfExchangeV9History": "PCF data exchange history",
    "publicationTemplates": "Publication templates",
    "certificateManagement": "Certificate management",
    "certificates": "Certificates",
    "connectors": "My connectors"
  },
  "versionModal": {
    "title": "General Information",
    "error": "Failed to fetch version details",
    "table": {
      "title": "Component Details",
      "componentName": "Component Name",
      "imageVersion": "Image Version",
      "chartVersion": "Chart Version"
    }
  },
  "dropdown": {
    "selectAll": "Select All",
    "noOption": "No options available",
    "noSuchOption": "There is no such option ...",
    "selectConnection": "Select a connection"
  },
  "certificateManagement": {
    "title": "Business Partner Certificate Management",
    "description": "Welcome to the easy to use end-to-end Business Partner Certificate Management exchange solution in Catena-X.",
    "howTo": {
      "description": "Discover the data offer catalog of other Catena-X member companies. You can search, select and subscribe to a certificate offer. You can search for certificate offers using the company name.",
      "doc": "Want to know more about how business partner certificate management work? "
    },
    "landingTiles": {
      "tile_1": {
        "title": "Publish certificate",
        "description": "Create and share your site certificates in Catena-X network."
      },
      "tile_2": {
        "title": "Discover and consume certificates",
        "description": "Easily search and download  site and business certificates."
      },
      "tile_3": {
        "title": "Published certificates history",
        "description": "Overview of all your provided certificates"
      },
      "tile_4": {
        "title": "Consumed certificates history",
        "description": "Overview of all your consumed certificates"
      },
      "tile_5": {
        "title": "Inbound certificate requests",
        "description": "Overview of incoming requests to share certificates"
      },
      "tile_6": {
        "title": "Outbound certificate status",
        "description": "Overview of actions to share certificates"
      },
      "tile_7": {
        "title": "Request certificates",
        "description": "Easily search and download  site and business certificates."
      }
    },
    "recentCertificateRequests": "Recent inbound certificate data requests",
    "learnMore": "Learn more about Certificate Management",
    "requestCertificates": "Request new certificates",
    "pushCertificate": "Push existing certificate",
    "pushDescription": "The existing certificate will be shared to the partner selected below. Please keep in mind that the same set of policies will apply as it is in the original offer. If you wish to change the policies, please create a new data offer.",
    "pushSuccess": "Certificate pushing process started! Job id is {id}",
    "receiverBpn": "Receiver BPN",
    "providerBpn": "Provider BPN",
    "locationBpns": "Site BPNA/BPNS",
    "certificateType": "Certificate type",
    "requestSuccess": "Certificate request successfully submitted!",
    "pushResult": "{successful} out of {total} {status} requests succeeded!",
    "receiveConfirmTitle": "Acknowledge certificate receipt",
    "receiveConfirmDesc": "By clicking yes, you acknowledge that you have received the certificate shared by the partner. The provider will get your acknowledgement. As a next step, you can accept or reject the certificate.",
    "acceptedConfirmTitle": "Accept certificate",
    "acceptedConfirmDesc": "By clicking yes, you accept that the certificate matches the expectations. You can download the certificate as a PDF by clicking on view icon.",
    "rejectedConfirmTitle": "Reject certificate",
    "rejectedConfirmDesc": "By clicking yes, you reject the incoming certificate. The provider will be notified of the rejection status. The provider can either share again or you can request a new certificate again.",
    "processStarted": "'{type}' Process started! Job id is {id}",
    "certificateDetails": "Certificate details",
    "availableCertificate": "Available certificate location",
    "updateSuccess": "Certificate updated successfully!",
    "updateFailure": "Certificate update failed!",
    "wizard": {
      "selectCompanies": "Select Companies",
      "selectPolicies": "Select Policies"
    },
    "step1Description": "Select one or more companies to share the certificate with. Click next to proceed to policy selection.",
    "step2Description": "Select the policies for the certificate sharing. Each policy is associated with a BPN from your selected companies.",
    "noPoliciesFound": "No policies found for the selected companies.",
    "policiesFound": "{count} policies found",
    "selectedPolicies": "{count} selected",
    "policyName": "Policy Name",
    "bpn": "BPN",
    "assetId": "Asset ID",
    "policyType": "Type",
    "errorFetchingPolicies": "Failed to fetch policies. Please try again.",
    "noPoliciesFoundInCatalog": "No policies found in the catalog for the selected companies.",
    "duplicateBpnError": "You can't select the same BPN twice.",
    "membershipValue": "Membership",
    "contractReference": "Contract reference",
    "noCompatibleOfferPush": "No CCM-Push compatible offer found. Ask your selected Business Partner(s) to publish one.",
    "noCompatibleOfferAvailable": "No CCM-Available compatible offer found. Ask your selected Business Partner(s) to publish one."
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "Basic Certificate Information",
        "issuer": "Issuer Information",
        "validity": "Validity Period",
        "trust": "Trust Information",
        "validator": "Validator Information",
        "application": "Application Area",
        "enclosedSites": "Enclosed Sites"
      },
      "fields": {
        "businessPartnerNumber": "Business Partner Number",
        "registrationNumber": "Registration Number",
        "certificateType": "Certificate Type",
        "certificateVersion": "Certificate Version",
        "issuerName": "Issuer Name",
        "issuerBpn": "Issuer BPN",
        "validFrom": "Valid From",
        "validUntil": "Valid Until",
        "trustLevel": "Trust Level",
        "uploaderBpn": "Uploader BPN",
        "validatorBpn": "Validator BPN",
        "validatorName": "Validator Name",
        "areaOfApplication": "Area of Application",
        "siteBpn": "Site BPN",
        "siteAreaOfApplication": "Site Area of Application"
      },
      "tooltips": {
        "basicInfo": "A business partner certificate describes a certificate (eg ISO9001, IATF-16949) via a certifcate document of a Catena-X business partner",
        "businessPartnerNumber": "The Business Partner Number (BPN) of the certified legal entity (on which the certificate is issued).",
        "registrationNumber": "Registration number of the certificate as defined on the certificate",
        "certificateType": "Type of the certificate as defined on the document,valid types are registered at BPN metadatacontroller",
        "certificateVersion": "Version of the certificate as defined on the document, usually the specific version of a certification standard",
        "issuerName": "Name of the Issuer i.e. Certifying Authority.",
        "issuerBpn": "The Business Partner Number (BPN) of the Issuer.",
        "validFrom": "Valid from date as defined on the certificate.",
        "validUntil": "Valid valid until as defined on the certificate. If certificate never expires value until expected to be 9999-12-31",
        "trustLevel": "The trust level of the given certificate - none,low, high, trusted",
        "uploaderBpn": "The Business Partner Number (BPN) of the business partner who originally provided the certifcate data or document.",
        "validatorBpn": "The Business Partner Number (BPN) of the data service provider who validated the given certificate",
        "validatorName": "The optional name of the data service provider who validated the given certificate",
        "areaOfApplication": "Details on which areas / application types a certificate is valid for a company and/or site.",
        "siteBpn": "The Business Partner Number (BPNS or BPNA) of an enclosed site",
        "siteAreaOfApplication": "Details on which areas / application types a certificate is valid for a company and/or site."
      }
    }
  },
  "common": {
    "start": "Start",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email address",
    "phoneNumber": "Phone number",
    "contactPerson": "Contact person",
    "welcome": "Welcome",
    "street": "Street",
    "city": "City",
    "country": "Country",
    "postCode": "ZIP code",
    "number": "Number",
    "next": "Next",
    "prev": "Back",
    "alreadyAccount": "Already have an account?",
    "login": "Log in",
    "loginNow": "Log in now",
    "register": "Register",
    "home": "Home",
    "submit": "Submit",
    "attention": "Attention",
    "desc": "Description",
    "website": "Website",
    "contact": "Contact",
    "details": "Details",
    "plan": "Plan",
    "table": "Table",
    "grid": "Grid",
    "listView": "List view",
    "gridView": "Grid view",
    "firstPage": "To the first page",
    "previousPage": "To the previous page",
    "nextPage": "To the next page",
    "lastPage": "To the last page",
    "paginationUnknownButton": "Unknown pagination button type",
    "download": "Download",
    "delete": "Delete",
    "edit": "Edit",
    "information": "Information",
    "organization": "Organization",
    "cancel": "Cancel",
    "save": "Save",
    "upload": "Upload",
    "link": "Link",
    "view": "View",
    "search": "Search",
    "selectOption": "Select an option",
    "sortBy": "Sort by",
    "dataspace": "Dataspace",
    "select": "Select",
    "date": "Date",
    "title": "Title",
    "back": "Back",
    "startTyping": "Start typing",
    "useCases": "Use cases",
    "done": "Done",
    "enterValue": "Enter a value",
    "isRequired": "is required",
    "confirmationRequired": "Please confirm by checking the box",
    "selectValue": "Select a value",
    "selectDate": "Select a date",
    "selectYear": "Select year",
    "refresh": "Refresh",
    "provided": "Provided",
    "consumed": "Consumed",
    "searchByName": "Search by name",
    "close": "Close",
    "copyToClipboard": "Copied to clipboard!",
    "enterKeyName": "Enter key name",
    "fileDownloadSuccess": "File downloaded successfully",
    "fileDownloadError": "File download failed",
    "certificate": "Certificate",
    "manageConnections": "Manage connections",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "connectionDetails": "{type} connection details",
    "hide": "Hide",
    "unpublish": "Unpublish",
    "severity": "Severity",
    "expectedResponseBy": "Expected Response By",
    "clear": "Clear",
    "viewAll": "View all",
    "apply": "Apply",
    "from": "From",
    "to": "To",
    "send": "Send",
    "update": "Update",
    "createSend": "Create & Send",
    "share": "Share",
    "recentRequests": "Recent requests",
    "active": "Active",
    "viewDocs": "View docs",
    "request": "Request",
    "noData": "No data",
    "autosaving": "Autosaving",
    "connectIntegrate": "Connect & Integrate"
  },
  "searchableSelect": {
    "pressEnterToUse": "Press Enter to use this BPNA/BPNS",
    "placeholderText": "Please enter a valid BPNA/BPNS",
    "placeholder": "Select or enter a BPNA/BPNS",
    "validBpnWarning": "Warning! The entered BPNA/BPNS value is not validated against any source, unlike in BP Explore. If you still want to use it, press Enter.",
    "enterValidBpn": "Enter valid BPNA/BPNS (expected format ^(BPNA|BPNS).{12}$)"
  },
  "genericError": "Oh, something went wrong! Please try again.",
  "validation": {
    "fieldRequired": "{field} is required.",
    "fieldNumeric": "The field {field} may contain only numbers.",
    "fieldAlpha": "The field {field} may contain only letters, _ and -.",
    "fieldAlphanumeric": "The field {field} may contain only letters, numbers, _ and -.",
    "fieldNumericDash": "The field {field} may contain only numbers and -.",
    "fieldHouseNumber": "The field {field} may contain only numbers, letters, and the characters - and /.",
    "fieldPhoneNumber": "The field {field} may contain only numbers and -. It must start with + or 00.",
    "fieldAlphaDash": "The field {field} may contain only letters and -.",
    "exceptHTMLTagBrackets": "The field {field} must not contain the following characters: ^<>",
    "isMaxLength": "exceeds the maximum length of 10 characters.",
    "emailFormat": "Email address has wrong format",
    "fileSizeError": "The file size is bigger than {size} MB.",
    "csvFileSizeError": "This file is too big. You can upload file up to {size} MB.",
    "csvFileExtensionError": "Only files with the csv extension are allowed.",
    "csvFileIsEmptyError": "This file is Empty. You need to upload at least {size} KB file.",
    "csvFileFormatError": "The file does not match the expected format. Please use provided template and try again.",
    "uploadFails": "upload failed",
    "fileExtensionError": "The file extension is not suitable",
    "fileIsMalwareInfectedError": "This file seems to contain malwares. For security reasons this file cannot be uploaded. Please check your file again",
    "customValidation": "The {field} has the wrong format.",
    "selectCountryFirst": "Please select Country name first",
    "validationPostCodeCaseDE": "The field has the wrong format. It must contain 5 digits, e.g., 53113",
    "validationAlphanumericCase": "The field may contain only alphanumeric characters, dashes, and underscores. The value must start with an alphanumeric character.",
    "validationNumericDashCase": "The field may contain only numbers and -.",
    "url": "Please enter a valid URL",
    "required": "This field is required",
    "password": {
      "passwordStrength": "Password strength",
      "weak": "Weak",
      "average": "Average",
      "strong": "Strong",
      "passwordValidationMoreChar": "{count} or more characters",
      "passwordUpperAndLowerChar": "Upper and lower case characters",
      "passwordAtLeastNumber": "At least one number",
      "passwordAtLeastSpecialChar": "At least one special character (except <>&\"`[])",
      "passwordDiffFromPrev": "Differs from your previous passwords"
    }
  },
  "footer": {
    "tagLine": "Let's power higher performance",
    "imprint": "Imprint",
    "imprintShort": "Imprint",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "Contact",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "Terms & Conditions",
    "privacy": "Privacy policy",
    "privacyShort": "Privacy policy",
    "telekom": "T-Systems International GmbH. All rights reserved.",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub - For Business Customers only",
    "brandedNote": "Powered by Telekom Data Intelligence Hub",
    "cookieSettings": "Cookie settings",
    "cookieSettingsShort": "Cookies",
    "life": "Life is for sharing"
  },
  "cookieSettings": {
    "collapsedTitle": "Privacy settings",
    "collapsedText": "This website uses cookies and similar technologies. These are small text files that are stored and read on your computer. By clicking on '{0}', you accept the processing, the creation of individual user profiles across websites and partners, and the transfer of your data to third parties, some of whom process your data in countries outside the European Union (GDPR Art. 49). Details can be found in section'2 of the {1}. The data is used for analysis, retargeting and for playing out personalized content and advertising on Telekom sites and third-party sites. Further information, including information on data processing by third-party providers and the possibility of revocation, can be found in the settings and in our privacy information. Here you can {2} only with the necessary tools.",
    "extendedTitle": "Privacy settings",
    "extendedText": "In order to provide you with an optimal website experience, we use cookies. These include cookies for the operation and optimization of the site as well as for services such as text or video chat and for advertising based on your online usage behavior. This allows us, for example, to detect if you visit our pages repeatedly from the same device. We would like to give you the choice which cookies you allow:",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "privacy information",
    "policyLinkText": "Privacy information",
    "rejectLinkText": "continue",
    "acceptButton": "Accept all",
    "saveButton": "Save settings",
    "settingsButton": "Change settings",
    "showMore": "Show more",
    "showLess": "Show less",
    "categoryTitleEssential": "Required cookies",
    "categoryTitleAnalytics": "Analytical cookies",
    "categoryTitleMarketing": "Marketing cookies",
    "categoryTitleThirdParty": "Services by other companies (independent third party providers)",
    "categoryTextEssential": "These cookies are required to enable you to navigate through the websites and use key functions. They support basic functions, such as order processing in the online shop and access to secured areas of the web page. They also serve the purpose of performing an anonymous analysis of user patterns, which we use to continuously develop and improve our web pages for you.",
    "categoryTextAnalytics": "These cookies help us to improve our understanding of user behavior. Analysis cookies allow for the compilation of usage and identification data by the original provider or third party providers into pseudonymous usage profiles. We use analysis cookies e.g. to determine the number of individual visitors to a web page or a service, to collect statistical data on the performance of our products and to analyze the visitors' usage patterns and visitor interactions on the basis of anonymous and pseudonymous information. This information cannot be traced back to a person.",
    "categoryTextMarketing": "These cookies and similar technologies are used to enable the display of personalized and therefore relevant marketing content. Marketing cookies are used to display interesting advertising content and to measure the effectiveness of our campaigns. This happens not only on Telekom websites, but also on other advertising partner sites (third-party providers). This is also called retargeting. It is used to create pseudonymous content or ad profiles, to place relevant advertising on other websites, and to derive insights into target groups that have viewed the ads and content. This information cannot be traced back to a person. Marketing and retargeting tools assist us in serving you advertising content that is potentially relevant for you. By suppressing marketing cookies, you will still see the same amount of advertising, but it may be less relevant to you.",
    "categoryTextThirdParty": "Telekom's websites include links to third-party service providers, who provide their services under their own responsibility. When you visit Telekom's web pages, cookies or similar technologies record data and send it to third parties, in part for Telekom's own purposes. The scope, purpose, and legal basis on which further processing is carried out for the third party's own purposes can be found in the third party's data privacy information. Information on the independent third-party providers can be found in the data privacy information."
  },
  "messages": {
    "noDataAvailable": "No data available",
    "noMatchFound": "No match found",
    "maximumFileSize": "Maximum file size",
    "suitableFileFormats": "Suitable file formats",
    "loading": "Loading...",
    "dragDropText": "or drag and drop it here",
    "noConnectors": "No connectors found!",
    "comingSoon": "Coming soon"
  },
  "pageNotFound": {
    "title": "Oops! Looks like the page you are looking for doesn't exist yet.",
    "subtitle": "Check out our other resources in the meantime, which might be helpful for you!"
  },
  "helpResources": {
    "needHelp": "Need help in finding the right plan, more info, technical questions?",
    "needHelpShorter": "Need more help?",
    "developerDoc": "API Documentation",
    "developerDocDesc": "Get API documentation for data exchange automation",
    "example": "Example",
    "examples": "User Guide",
    "tutorials": "Tutorials",
    "exampleDescription": "Find use cases and demos relevant to your Industrial sector",
    "FAQ": "Frequently Asked Questions",
    "FAQDescription": "Find more common answers from billing to privacy",
    "browse": "Browse",
    "demos": "Demos",
    "demosDescription": "Find use cases and demos relevant to your Industrial sector",
    "glossary": "Glossary",
    "glossaryDescription": "Find the Terms and Definitions related to Data Intelligence Hub, IDSA, Catena-X, Gaia-X and more.",
    "glossaryDescriptionShorter": "Find the term and definitions of Catena-X, Gaia-X and more",
    "customerSupport": "Customer support",
    "customerSupportDesc": "Couldn't find what you were looking for?",
    "contactUs": "This feature is not supported in your current subscription. Please contact us to upgrade.",
    "contactUsBtn": "Contact us"
  },
  "basicInfo": {
    "title": "Basic info",
    "dataspace": "Dataspace",
    "bpn": "Business Partner Number"
  },
  "feedbackCard": {
    "title": "Need more help?",
    "contactUs": "Contact us"
  },
  "error": {
    "pageNotFound": "Page not found (404)",
    "somethingWrong": "Something went wrong!",
    "propertyNotFound": "Property not found",
    "uniquePropertyName": "Property name must be unique",
    "dctTypeNotFound": "dct:type not found"
  },
  "helpWidget": {
    "askSupport": "Ask support",
    "chatboxTitle": "Help chat",
    "chatboxSubtitle": "Telekom Data Intelligence Hub support",
    "defaultMessage": {
      "body": "Hi there, welcome to the Telekom Data Intelligence Hub support channel. Please select an option below."
    },
    "whatCanWeHelpWith": "What can we help you with today?",
    "suggestedAnswers": {
      "knowledgeBase": "Knowledge-base, documentation and FAQs",
      "contactSupport": "Contact support",
      "contactSales": "Contact sales"
    }
  },
  "pcfExchange": {
    "title": "PCF Exchange",
    "description": "Welcome to the easy to use end-to-end Product Carbon Footprint (PCF) exchange solution in Catena-X.",
    "recentRequests": "Recent PCF data requests",
    "viewAllRequests": "View all requests",
    "requestPcf": "Request PCF",
    "termCheck": "By submitting the request, I understand that the contract will be negotiated on the data offer as per the policies set by the data provider.",
    "pcfSuccess": "PCF requested successfully!",
    "landing": {
      "pcfTitle": "Create PCF offer",
      "pcfDesc": "Create and share the PCF data with participants in Catena-X network.",
      "discoverTitle": "Discover & request pcf data",
      "discoverDesc": "Easily search PCF data in the Catena-X network or request the PCF data from your partners in few steps.",
      "pcfReqTitle": "PCF data requests",
      "pcfReqDesc": "Efficiently manage the PCF data requests from your partners in the Catena-X network.",
      "pcfCalcTitle": "PCF Calculator",
      "pcfCalcDesc": "Calculate the PCF values and connect to your applications or   PCF data exchange scenarios seamlessly.",
      "pcfHistoryTitle": "PCF data exchange history",
      "pcfHistoryDesc": "Gain transparency over your PCF data exchange history in the Catena_X network and your partners.",
      "documentation": "Learn about the PCF data exchange",
      "howTo": {
        "description": "Share, discover and manage the product carbon footprint (PCF) data offers within. Catena-X.",
        "doc": "Want to know more about Connect & Integrate? Documentation link: "
      }
    },
    "requests": {
      "pcfRequests": "PCF data requests",
      "reqDesc": "Use the area to manage your PCF data requests from partners.",
      "productId": "Product ID*",
      "bpn": "BPN*",
      "message": "Message",
      "howTo": {
        "title": "Want to know more about the PCF data request management work?",
        "description": "Utilize this section to approve or reject the PCF data request from your partners. Further, view the statuses of the pcf data exchanges and gain full transparency in your PCF data chain.",
        "doc": "Want to know more about how data offer negotiation and consumption work?"
      }
    },
    "responses": {
      "howTo": {
        "description": " Discover the data offer catalog of other Catena-X member companies. You can search, select and subscribe to a data offer. You can search for data offers using the company name or with the Manufacturer Part ID or with a combination of two."
      }
    },
    "view": {
      "title": "View PCF Details"
    }
  },
  "pcfExchangeV9": {
    "landing": {
      "pcfReqTitle": "PCF Provider",
      "pcfHistoryTitle": "PCF Consumer"
    },
    "incomingRequests": "Incoming PCF Requests",
    "sentResponses": "Sent PCF Responses",
    "sentRequests": "Sent PCF Requests",
    "incomingResponses": "Incoming PCF Responses",
    "requests": {
      "pcfRequests": "PCF Provider",
      "partIdDescription": "Provide either the Manufacturer Part ID or the Customer Part ID. At least one of these is required.",
      "manufacturerPartId": "Manufacturer Part ID",
      "customerPartId": "Customer Part ID",
      "eitherPartIdRequired": "Either Manufacturer Part ID or Customer Part ID is required."
    }
  },
  "cyberSecurityKPIs": {
    "title": "Cyber security metrics",
    "historyTitle": "Sent cyber security metrics history",
    "historySubTitle": "Here you can see the shared data history",
    "description": "Welcome to the easy to user cyber security data sharing with you OEM",
    "nothinghere": "Nothing here yet!",
    "newEntryAppearance": "When you will create a new entry, it will appear here.",
    "createKPITitle": "Create and send cyber security metrics",
    "createKPISubTitle": "Please ensure to fill all the details in one go. Data will not be saved if you choose to cancel before sending. If you choose to cancel, you will be redirected to the use-case dashboard and you will have to fill in the details from the start.",
    "createKPIDocumentationDesclaimer": "For more information on how to fill in the form and other requirements from the OEM, please follow our {documentation}.",
    "documentation": "Documentation",
    "generalInformation": "General information",
    "measurementYear": "Measurement year",
    "receiverBpn": "Receiver BPN",
    "confirmationText": "By submitting the request, I understand that the contract will be negotiated on the data offer as per the policies set by the data provider.",
    "successTitle": "Success",
    "successDescription": "Your data is successfully shared. Job id is {id}",
    "sendMetricsFailed": "Error in sharing your data.",
    "kpiKnowledgeBase": "Learn more about the use-case",
    "kpiFirstEntry": "Get started and create your first entry",
    "metricsInformation": {
      "title": "Metrics information",
      "measurementDate": "Measurement date",
      "value": "Value",
      "kpiNotSharedReason": "Reason for not sharing the metric",
      "enclosedSiteTitle": "Enclosed sites",
      "enclosedSiteLabel": "Select your enclosed sites"
    },
    "modal": {
      "leaveTitle": "Leave without saving?",
      "leaveDescription": "If you close this form now, your entered data will be lost.",
      "discardBtn": "Discard changes",
      "continueEditingBtn": "Continue editing",
      "confirmTitle": "Confirm sending",
      "confirmDescription": "Once sent, this message cannot be edited or recalled.",
      "confirmReviewBtn": "Review again"
    },
    "helpCard": {
      "title": "How does it work?",
      "description": "Share the annual cyber security KPI data with BMW. Get complete overview of all previously recorded information here.",
      "subtitle": "Want to know more about Cyber security metrics use-case work?"
    },
    "metricsViewer": {
      "jobId": "Job ID",
      "threadId": "Thread ID",
      "stepId": "Step ID",
      "header": "Headers",
      "messageId": "Message ID",
      "senderBpn": "Sender BPN",
      "receiverBpn": "Receiver BPN",
      "senderFeedbackUrl": "Sender feedback URL",
      "content": "Content",
      "reportId": "Report ID",
      "kpiShared": "KPI shared"
    }
  },
  "publicationTemplates": {
    "title": "My publication templates",
    "deletedTemplates": "My deleted templates",
    "showDeletedTemplates": "Show deleted templates",
    "hideDeletedTemplates": "Show active templates",
    "newTemplate": "New template",
    "create": {
      "title": "Create publication template",
      "edit": "Edit publication template",
      "templateName": "Template name",
      "templateType": "{type} template",
      "create": "Create",
      "update": "Update",
      "modifiedAt": "Modified at",
      "accessPolicyId": "Access policy",
      "usagePolicyId": "Usage policy",
      "isEnabled": "Is Enabled",
      "targetCompany": "Target company",
      "targetConnectors": "Target connectors",
      "selectCountry": "Select a country",
      "templateDetails": "Publication template details",
      "assetsCriteria": "Asset selection criteria",
      "connectorDetails": "Connector details"
    },
    "delete": {
      "title": "Delete publication template",
      "description": "Are you sure you want to delete this template?",
      "button": "Delete"
    }
  },
  "contracts": {
    "title": "Contract Agreements Details",
    "provider": {
      "description": "This is an overview of contract agreements your organization has with other dataspace participants.",
      "note": "Please note that the list below shows the data across all use-cases. We will soon introduce pre-filtered data list below as well as advanced searching and filtering per use-case. In the meantime, please use the search and filtering options to find relevant data from the list below.",
      "howItWorks": {
        "description": "Here you can find all your subscribed or negotiated data agreements across various dataspaces. You can filter the results for a particular connector or simply search with a contract agreement ID or Asset ID. You can also sort the list to view data agreements based on your requirements. Further, you can select the data offers and export them locally if you wish to.",
        "subtitle": "Want to know more about how data offer negotiation and consumption work?"
      },
      "details": {
        "title": "Provided Contract Agreements Details",
        "description": "Description",
        "content": "Content",
        "agreementDetails": "Agreement Details",
        "assetDetails": "Asset Details",
        "usagePolicy": "Usage Policy"
      }
    },
    "consumer": {
      "description": "This is an overview of contract agreements your organization has for data offers of other dataspace participants ",
      "downloadData": "Download data",
      "downloadAgreement": "Download agreement",
      "reinitiate": "Initiate transfer & download data",
      "error": {
        "heading": "Sorry! Looks like you have already negotiated this contract.",
        "body": "You cannot re-negotiate an already negotiated contract. You can find the contract details blow also you can download this agreement and subscribe data."
      },
      "details": {
        "title": "Consumed Contract Agreements Details"
      },
      "howItWorks": {
        "description": "Here you can find all your subscribed or negotiated data agreements across various dataspaces. You can filter the results for a particular connector or simply search with a contract agreement ID or Asset ID. You can also sort the list to view data agreements based on your requirements. Further, you can select the data offers and export them locally if you wish to.",
        "subtitle": "Want to know more about how data offer negotiation and consumption work?"
      }
    }
  },
  "provider": {
    "provider": "Provider",
    "assets": {
      "title": "My assets",
      "offeredBy": "Offered by:",
      "offers": "Offers",
      "created": "Created",
      "modifiedAt": "Modified at",
      "noResultsFound": "No assets were found",
      "success": "Asset created successfully",
      "updateSuccess": "Asset updated successfully",
      "buttons": {
        "createOffer": "Create offer",
        "details": "View details",
        "delete": "Delete asset",
        "create": "Create asset",
        "edit": "Edit asset",
        "update": "Update asset",
        "showDeleted": "Show deleted assets",
        "hideDeleted": "Hide deleted assets",
        "restore": "Restore asset",
        "add": "Add key-value pair",
        "addJson": "Add json object",
        "editJson": "Edit json object",
        "saveJson": "Save JSON",
        "advanceAddition": "Advance addition",
        "unpublish": "Unpublish asset",
        "showAssets": "Show assets"
      },
      "detailsDialog": {
        "title": "Asset details"
      },
      "createDialog": {
        "title": {
          "general": "Create new asset",
          "edit": "Edit asset",
          "addProperties": "Add properties",
          "advance": "Advance property addition"
        },
        "publicProps": "Public properties",
        "privateProps": "Private properties",
        "dataAddress": "Data address",
        "dataSources": "Data source",
        "dataDestination": "Data destination",
        "json": {
          "fields": "Json fields",
          "editor": "Custom properties editor",
          "formatted": "Custom properties viewer",
          "error": "Invalid JSON:",
          "placeholder": "Enter custom properties JSON"
        },
        "connectionTypeLabel": {
          "http": "Enter the URL",
          "s3": "Enter the object name",
          "azure": "Enter the blob name",
          "sftp": "Enter the file name"
        },
        "fields": {
          "name": "Name",
          "namePlaceholder": "Enter the offer name",
          "description": "Description",
          "version": "Version",
          "contentType": "Content type",
          "contentTypePlaceholder": "Enter content type",
          "keywords": "Keywords",
          "language": "Language",
          "languagePlaceholder": "Select language",
          "semanticId": "Semantic ID",
          "semanticIdPlaceholder": "Please insert the semantic ID",
          "dct:type": "dct:type",
          "dct:typePlaceholder": "Choose a dct type",
          "keywordsPlaceholder": "Add keywords",
          "descriptionPlaceholder": "Write the offer description",
          "versionPlaceholder": "Version number",
          "dataType": "Data address type",
          "dataTypePlaceholder": "Select data address type",
          "dataAddressUrl": "Asset Url",
          "dataAddressUrlPlaceholder": "Enter the asset Url",
          "targetCompany": "Target company",
          "targetCompanyPlaceholder": "Insert a target company",
          "country": "Country",
          "countryPlaceholder": "Insert a country",
          "key": "Key",
          "keyPlaceholder": "Enter the key",
          "value": "Value",
          "valuePlaceholder": "Enter the value",
          "assetType": "Asset type",
          "assetTypePlaceholder": "Enter asset type"
        },
        "validation": {
          "name": "Please enter a name",
          "assetType": "Please select an asset type",
          "contentType": "Please enter a valid content type",
          "dataType": "Please select a valid data type",
          "targetCompany": "Please enter a valid target company",
          "country": "Please enter a valid country"
        }
      },
      "tags": {
        "restricted": "Acccess restricted",
        "unrestricted": "Unrestricted"
      },
      "search": {
        "title": "Search filters",
        "helperText": "Search for asset name, create date or type",
        "filters": {
          "byName": "Asset name",
          "byType": "Asset type",
          "byDate": "Modification date"
        }
      },
      "delete": {
        "title": "Delete asset",
        "description": "Are you sure you want to delete this asset?"
      },
      "unpublish": {
        "title": "Unpublish asset",
        "description": "Are you sure you want to unpublish this asset?"
      }
    },
    "fileUploadTerms": "I understand and confirm that I have correctly filled in all the required information and T-Systems is not liable in case of incorrect information and offer rejection.",
    "fileUploadInfo": "T-Systems does not check the validity of the metadata information filled here. Please ensure that you have filled in correct and complete information.",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "Single entry",
    "bulkEntries": "Bulk entries"
  },
  "home": {
    "title": "Connect & Integrate",
    "welcomeBack": "Welcome back"
  },
  "gettingStarted": {
    "title": "Need help getting started?",
    "openWizard": "Open Wizard",
    "yourDataOffering": "Your data offering",
    "yourAssets": "Assets",
    "yourPolicies": "My policies",
    "preconfiguredCatalogue": "Preconfigured catalogue",
    "contractAgreements": "Contract agreements",
    "incomingAgreements": "Incoming agreements",
    "outgoingAgreements": "Outgoing agreements",
    "connectors": "Your connectors",
    "providedAgreements": "Provided contract agreements",
    "consumedAgreements": "Consumed contract agreements",
    "totalContracts": "Total contracts"
  },
  "yourConnection": {
    "title": "Your connectors",
    "viewAllConnection": "View all connectors",
    "help": "Help",
    "documentation": "Get to know your Connect & Integrate",
    "gettingStarted": "Getting started guide",
    "noUseCases": "No use cases available",
    "activeUseCases": "Active use cases",
    "useCasesAvailableToActivate": "use cases available to activate",
    "open": "Open",
    "show": "Show",
    "pcfVersionModal": {
      "title": "PCF Exchange Versions",
      "description": "Connect & Integrate supports the following PCF versions and rulebook deployments for PCF exchange within Catena-X network. Please select your preferred option. Please note the two versions are not connected.",
      "current": "Current",
      "deprecated": "Deprecated",
      "rulebook": "Rulebook",
      "pcfSubmodel": "PCF Submodel",
      "supportStatus": "Support Status",
      "statusActive": "Active",
      "statusEol": "End of Life",
      "saturn": {
        "name": "Saturn",
        "description": "Latest version with enhanced features and full support for current sustainability standards. Recommended for all deployments."
      },
      "jupiter": {
        "name": "Jupiter",
        "description": "Legacy version maintained for backward compatibility. Migration to Saturn strongly recommended before end of support period."
      }
    }
  },
  "wizardSelectionPopup": {
    "whatToLike": "What would you like to do today?",
    "prepare": "Prepare",
    "govern": "Govern",
    "provide": "Provide",
    "consume": "Consume",
    "howToProvide": "How would you like to provide data today?",
    "manual": "Manual",
    "automated": "Automated via an API",
    "selectUseCases": "Select your use case(s)",
    "selectSingleUseCase": "Select your use case",
    "selectDigitalTwin": "Select your digital twin type",
    "back": "Back",
    "publish": "I understand the framework requirements of the dataspace and I agree to publish the data offer in the dataspace on behalf of my organization."
  },
  "createOffer": {
    "title": {
      "standard": "Create data offer",
      "pcf": "Create PCF data offer",
      "certificate": "Create Certificate Offer",
      "traceability": "Create Traceability data offer"
    },
    "publish": "Publish",
    "legalConfirmation": "I understand the framework requirements of the dataspace and I agree to publish the data offer in the dataspace on behalf of my organization.",
    "wizard": {
      "provisionAsset": "Provision asset",
      "dataUpload": "Data selection",
      "attachPolicy": "Attach policy",
      "publishDataOffer": "Publish data offer"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "For which submodel would you like to create a data offer?",
      "selectSubmodel": "Select submodel",
      "selectUsecase": "Select a Use Case",
      "selectDigitalTwinType": "Select a digital twin type",
      "whichTypeToSelect": "Which type should I select?",
      "generalInformation": "General Information",
      "description": "Description",
      "contentType": "Content Type",
      "keywords": "Keywords",
      "language": "Language",
      "location": {
        "title": "Location and addressing",
        "text": "Please enter the details of your asset"
      },
      "username": "Username",
      "password": "Password",
      "assetUrl": "Asset Url",
      "assetUrlPlaceHolder": "Please insert your asset URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "tokenUrl": "Token Url",
      "tokenUrlPlaceHolder": "Please insert your token URL",
      "provideAssets": "Provide asset",
      "selectConnectorLabel": "Select which connector(s) you would like to share your data with",
      "selectConnectorPlaceholder": "Select a connector",
      "selectRestApiType": "Select REST-API type",
      "selectedAuthMethod": "Authentication method"
    },
    "dataUpload": {
      "selectUploadType": "Select your upload type",
      "selectedDataModel": "Select your data",
      "csvUpload": {
        "title": "CSV file",
        "description": "Drag and drop your files here",
        "uploadFile": "Select File",
        "uploadFileDescription": "Prepare and upload the file you would like to exchange. You can download the sample file to help you get started with the  format required for Catena-X.",
        "uploadFileDescriptionNote1": "Download the template file from the link below",
        "uploadFileDescriptionNote2": "Fill in the provided file with details of your partners",
        "uploadFileDescriptionNote3": "Upload the file in the provided area",
        "partnerValidationNote": "If you would like to learn more about partner validation, please",
        "clickHere": "click here",
        "downloadTemplate": "Download Template",
        "downloadSampleCsv": "Download Sample CSV",
        "supportedFileTypes": "Supported file types:"
      },
      "jsonUpload": {
        "title": "JSON",
        "submodelJson": "Submodel JSON",
        "downloadTemplate": "Download Template",
        "downloadSampleJson": "Download Sample JSON",
        "uploadFileDescription": "Prepare and upload the file you would like to exchange.",
        "invalidJson": "The provided content is not valid JSON. Please check the input and try again.",
        "schemaValidationFailed": "Catena-X schema validation failed",
        "issue": "issue",
        "issues": "issues"
      },
      "operationMode": {
        "title": "Select operation mode",
        "description": "Now decide how the shell for this twin is obtained.",
        "createNew": {
          "title": "Create New Digital Twin",
          "description": "Register a new AAS shell in CX-Core"
        },
        "useExisting": {
          "title": "Use Existing Digital Twin",
          "description": "Link to a shell already in CX-Core"
        }
      },
      "useExisting": {
        "searchTitle": "Search existing shell in CX-Core",
        "catenaXId": "Catena-X ID",
        "search": "Search",
        "reset": "Reset",
        "noResults": "No matching Digital Twins found.",
        "searchError": "Failed to search Digital Twins. Please try again.",
        "matchingTypeNote": "Only shells matching the selected Digital Twin type are listed.",
        "propertiesTitle": "Digital Twin properties",
        "readOnly": "(read-only)"
      },
      "digitalTwinProperties": {
        "title": "Digital Twin properties",
        "specificAssetIds": "Specific Asset IDs"
      },
      "tableUpload": {
        "title": "Table",
        "description": "Provide custom table entries",
        "add": "Add"
      },
      "fileUpload": {
        "title": "File upload",
        "description": "csv, json"
      },
      "objectStorage": {
        "title": "Object storage",
        "description": "AWS, Azure, OTC or GCP"
      },
      "sftp": {
        "title": "SFTP Server",
        "description": "transfer via SFTP"
      },
      "apiUpload": {
        "title": "REST API",
        "description": "transfer via API",
        "authAndIdentiTitle": "Authentication and identification",
        "authAndIdentiDesc": "Please enter authentication details of your destination system",
        "selectApiType": "Select REST-API type",
        "locationAndAddrTitle": "Location and addressing",
        "locationAndAddrDesc": "Please enter the details of your asset",
        "assetUrl": "Asset URL",
        "username": "Username",
        "password": "Password",
        "clientId": "Client ID",
        "clientSecret": "Client Secret"
      }
    },
    "fileUpload": {
      "title": "Drag and drop your file here",
      "btnText": "Select file"
    },
    "attachPolicy": {
      "title": "Attach a policy to this data offer",
      "createPolicy": "Create a new policy",
      "bpnFieldTitle": "With whom do you want to exchange your data?",
      "howItWork": {
        "title": "How does it work?",
        "description": "We pre-configure the policies based on the Catena-X Use Case framework agreement. Access to your data will be allowed only for the provided Business Partner Numbers.",
        "knowMore": "Want to know more about the policies?",
        "documentation": "Documentation"
      },
      "accessPolicyTableText": "Attach an access policy to this data offer",
      "usagePolicyTableText": " Attach an usage policy to this data offer",
      "heading": {
        "title": "Attach existing policies or create new",
        "description": "Please attach both Access and Usage policy from the tables below to finish the data offer publication. You can also search for policies with policy names or create a new policy in case you don't have a desired policy yet."
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "Data offer details",
      "generalInformation": "General Information",
      "attribute": "Attribute",
      "value": "Value",
      "knowMore": "Know more about your data offer",
      "attachedDataAssets": "Attached items",
      "attachedPolicies": "Attached policies",
      "allowPolicyPublish": "I allow policy publication",
      "publish": "Publish",
      "verifiedLegalEntity": "Verified legal entity by",
      "dataOfferCreatedBy": "Data offer created by: ",
      "contactOrgAdmin": "Contact Organization Admin",
      "help": "Help",
      "attachedDataAsset": "Attached data asset",
      "attachedAccessPolicy": "Attached access policy",
      "attachedUsagePolicy": "Attached usage policy",
      "publishedConnectors": "Connectors to which this offer will be published",
      "knowMoreConnector": "Know more about your connectors",
      "knowMorePolicies": "Know more about your policies",
      "knowMoreDataAssets": "Know more about your data assets",
      "knowMoreDataOffers": "Know more about your data offer",
      "publishCheckboxLabel": "I, on behalf of my organization, agree to publish the data offer and assets in the dataspace. I confirm the usage of associated policies to govern the dataspace and associated policies and I will follow the framework of the dataspace for any operation on the offer and assets once published."
    },
    "result": {
      "success": {
        "title": "Successful request.",
        "description": "Asset publishing process started! Job id is {id}"
      }
    },
    "success": {
      "title": "Your data offer is now published",
      "description": "Your data offer is now published, click the following for the next steps",
      "createOffer": "Create another data offer",
      "createOfferButton": "Create",
      "goToHome": "Go to home",
      "goToHomeButton": "Go to home",
      "uploadHistory": "Check your upload history"
    }
  },
  "policy": {
    "newPolicy": "New policy",
    "showDeletedPolicies": "Show deleted policies",
    "myDeletedPolicies": "My deleted policies",
    "hideDeletedPolicies": "Show active policies",
    "restoreAsset": "Restore",
    "publishDeletion": "Publish deletion",
    "create": {
      "title": "Create new policy",
      "edit": "Edit policy",
      "policyName": "Policy name",
      "policyType": "{type} policy",
      "accessPolicy": "Access Policy",
      "usagePolicy": "Usage Policy",
      "create": "Create and save",
      "update": "Update"
    },
    "delete": {
      "title": "Delete policy",
      "description": "Are you sure you want to delete this policy?",
      "button": "Delete"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "Business Partner Number",
        "description": "The business partner number restriction can get used to define which exact business partners (based on BPNL) are allowed to view or negotiate the respective data offer. Please ensure that you add minimum one 16-digit BPNL Number in the rightOperand; wildcards are not supported."
      },
      "BusinessPartnerGroup": {
        "title": "Business Partner Group",
        "description": "The business partner group restriction can get used to define which exact business partners (based on BPNL) are allowed to view or negotiate the respective data offer. e.g. BusinessPartnerWithoutBilateralContract."
      },
      "Membership": {
        "title": "Membership",
        "description": "The membership credential can get used to ensure that only CX members are allowed to view or negotiate the respective data offer."
      },
      "ContractReference": {
        "title": "Contract Reference",
        "description": "The contract reference restriction can get used to define under which bilateral contract details the data are getting shared. Note that the exact bilateral contract name needs to get added inside the right operand."
      },
      "UsagePurpose": {
        "title": "Usage Purpose",
        "description": "Usage Purpose"
      },
      "FrameworkAgreement": {
        "title": "Framework Agreement",
        "description": "With the FrameworkAgreement Credential, only those participants which have signed the respective framework agreement (general or via a specific version) are allowed to view or negotiate the respective data offer. Generic: \"rightOperand\": \"active\"; specific \"rightOperand\": \"active:{version}\""
      },
      "Dismantler": {
        "title": "Dismantler",
        "description": "Companies holding the credential are dismantler certified companies.",
        "allowedBrands": {
          "title": "Dismantler Allowed Brands",
          "description": "Company role defining a dismantler. Companies holding the credential are dismantler certified companies."
        }
      },
      "Duration": {
        "title": "Duration",
        "description": "Duration for data usage from signing date."
      },
      "inForceDate": {
        "title": "Fixed Date Range",
        "description": "Fixed date time frame for data usage."
      },
      "connector": {
        "title": "Connector Restriction",
        "description": "Companies holding the connectors to use for there restriction."
      },
      "AffiliatesBpnl": {
        "title": "Affiliates",
        "description": "Documents (not: checks) the affiliate business partners."
      },
      "AffiliatesRegion": {
        "title": "Affiliates Region",
        "description": "Documents (not: checks) the affiliate regions."
      },
      "ConfidentialInformationMeasures": {
        "title": "Confidential Information Measures",
        "description": "Documents (not: checks) whether confidential measures have to be taken."
      },
      "ConfidentialInformationSharing": {
        "title": "Confidential Information Sharing",
        "description": "Documents (not: checks) whether confidential measures have to be taken."
      },
      "ContractTermination": {
        "title": "Contract Termination",
        "description": "Documents (not: checks) what consumer should do with the data after the contract is terminated."
      },
      "DataFrequency": {
        "title": "Data Frequency",
        "description": "Documents (not: checks) how often the asset can be transferred."
      },
      "DataProvisioningEndDate": {
        "title": "Data Provisioning End",
        "description": "Documents (not: checks) an absolute date when the provisioning of the asset ends."
      },
      "DataProvisioningEndDurationDays": {
        "title": "Data Provisioning Days",
        "description": "Documents (not: checks) how long the provisioning of the asset holds."
      },
      "DataUsageEndDate": {
        "title": "Data Usage End",
        "description": "Documents (not: checks) an absolute date when the consumption of the asset ends."
      },
      "DataUsageEndDurationDays": {
        "title": "Data Usage Days",
        "description": "Documents (not: checks) how long the consumption of the asset holds."
      },
      "DataUsageEndDefinition": {
        "title": "Data Usage End Definition",
        "description": "Documents (not: checks) how long the consumption of the asset holds."
      },
      "JurisdictionLocation": {
        "title": "Jurisdiction Location",
        "description": "Documents (not: checks) the jurisdiction of this contract in clear text"
      },
      "JurisdictionLocationReference": {
        "title": "Jurisdiction Location Reference",
        "description": "Documents (not: checks) the jurisdiction of this contract relative to the involved parties"
      },
      "Liability": {
        "title": "Liability",
        "description": "Documents (not: checks) the liability of this contract to the involved parties"
      },
      "ManagedLegalEntityBpnl": {
        "title": "Managed Legal Entity",
        "description": "Documents (not: checks) the business partners that the provider manages the asset for."
      },
      "ManagedLegalEntityRegion": {
        "title": "Managed Legal Entity Region",
        "description": "Documents (not: checks) the region that the provider manages the asset for."
      },
      "Precedence": {
        "title": "Precedence",
        "description": "Documents (not: checks) which contractual framework takes precedence"
      },
      "ExclusiveUsage": {
        "title": "Exclusive Usage",
        "description": "Documents (not: checks) that this asset is exclusively offered to the consumer"
      },
      "UsageRestriction": {
        "title": "Usage Restriction",
        "description": "Documents (not: checks) what the consumer may not do with this asset"
      },
      "VersionChanges": {
        "title": "Version Changes",
        "description": "Documents (not: checks) what kind of version changes to the asset may occur"
      },
      "Warranty": {
        "title": "Warranty",
        "description": "Documents (not: checks) what warranty the consumer gets for the asset"
      },
      "WarrantyDefinition": {
        "title": "Warranty Definition",
        "description": "Documents (not: checks) the warranty period the consumer gets for the asset"
      },
      "WarrantyDurationMonths": {
        "title": "Warranty Duration",
        "description": "Documents (not: checks) the warranty period the consumer gets for the asset in months."
      }
    },
    "fields": {
      "BusinessPartnerNumber": "Business Partner Number",
      "tx:BusinessPartnerGroup": "Business Partner Group",
      "cx-policy:Membership": "Membership",
      "cx-policy:ContractReference": "Contract Reference",
      "cx-policy:Dismantler.allowedBrands": "Dismantler Allowed Brands",
      "cx-policy:UsagePurpose": "Usage Purpose",
      "cx-policy:FrameworkAgreement": "Framework Agreement",
      "cx-policy:Dismantler": "Dismantler",
      "duration": "Duration",
      "unit": "Unit",
      "fromdate": "From Date",
      "todate": "To Date",
      "connector": "Connector",
      "cx-policy:AffiliatesBpnl": "Affiliates",
      "cx-policy:AffiliatesRegion": "Affiliates Region",
      "cx-policy:ConfidentialInformationMeasures": "Confidential Information Measures",
      "cx-policy:ConfidentialInformationSharing": "Confidential Information Sharing",
      "cx-policy:ContractTermination": "Contract Termination",
      "cx-policy:DataFrequency": "Data Frequency",
      "cx-policy:DataProvisioningEndDate": "Data Provisioning End",
      "cx-policy:DataProvisioningEndDurationDays": "Data Provisioning Days",
      "cx-policy:DataUsageEndDate": "Data Usage End",
      "cx-policy:DataUsageEndDurationDays": "Data Usage Days",
      "cx-policy:DataUsageEndDefinition": "Data Usage End Definition",
      "cx-policy:JurisdictionLocation": "Jurisdiction Location",
      "cx-policy:JurisdictionLocationReference": "Jurisdiction Location Reference",
      "cx-policy:Liability": "Liability",
      "cx-policy:ManagedLegalEntityBpnl": "Managed Legal Entity",
      "cx-policy:ManagedLegalEntityRegion": "Managed Legal Entity Region",
      "cx-policy:Precedence": "Precedence",
      "cx-policy:ExclusiveUsage": "Exclusive Usage",
      "cx-policy:UsageRestriction": "Usage Restriction",
      "cx-policy:VersionChanges": "Version Changes",
      "cx-policy:Warranty": "Warranty",
      "cx-policy:WarrantyDefinition": "Warranty Definition",
      "cx-policy:WarrantyDurationMonths": "Warranty Duration"
    }
  },
  "jobs": {
    "jobs": "Jobs",
    "name": "Name",
    "startedAt": "Started At",
    "duration": "Duration",
    "jobDetails": "Process Details",
    "reload": "Reload",
    "noDetailsAvailable": "No further details available for this job",
    "retry": "Retry"
  },
  "search-offer": {
    "pageTitle": "Search data offers",
    "pcfTitle": "Search for PCF data offers",
    "pcfV9Title": "Search for PCF data offers",
    "certificateTitle": "Search for business partner certificate offers",
    "traceabilityTitle": "Discover traceability data",
    "filter": {
      "bpnSearch": "Search by your business partner number or a company name",
      "bpnSearchNote": "Find the data offers by searching with the company name or BPN.",
      "manufacturePartId": "Manufacturer Part ID",
      "manufacturePartIdNote": "Searches for all data offers matching the given part ID.",
      "enter": "Enter {field}",
      "connectorUrl": "Connector URL",
      "connectorUrlNote": "Search for data within specific connectors",
      "subModel": "Submodel",
      "subModelNote": "Fine-tune your search results for your desired use-case",
      "search": "Search",
      "searchBy": "Search by",
      "resetFilters": "Reset filters",
      "advancedSearch": "Advanced search",
      "dct:type": "dct:type",
      "assetId": "Asset ID"
    },
    "noResult": {
      "title": "No result",
      "description": "Please search to browse available data offers in the network"
    },
    "helpCard": {
      "title": "How does it work?",
      "description": "Discover the data offer catalog of other dataspace participants. You can search, select and subscribe to available data offers in the dataspace.",
      "subtitle": "Want to know more about how data offer negotiation and consumption work?",
      "documentation": "Documentation"
    },
    "offers": {
      "downloadSelected": "Download Selected",
      "transferSelected": "Transfer Selected",
      "negotiate": "Negotiate",
      "noOffer": "No data offers are available."
    },
    "offer-details": {
      "title": "Confirm contract negotiations",
      "description": "Description",
      "attachedPolicies": "Attached policies",
      "termsCheck": "I agree to the contract terms and I want to start contract negotiation and data exchange.",
      "negotiate": "Negotiate",
      "negotiateAndDownload": "Negotiate and download",
      "negotiateAndTransfer": "Negotiate and transfer",
      "transfer": "Transfer",
      "cancel": "Cancel",
      "attribute": "Attribute",
      "value": "Value",
      "endpointUrl": "Endpoint URL",
      "organization": "Organization",
      "bpnNumber": "BPN Number",
      "manufacturerPartId": "Manufacturer Part ID",
      "noOfAssets": "Number of selected assets",
      "membership": "Membership",
      "dismantlerBrands": "Dismantler Allowed Brands",
      "frameworkAgreement": "Framework Agreement",
      "dismantler": "Dismantler",
      "backToAssets": "Back to assets",
      "noPolicyMatchTitle": "Assets not negotiated or policies not identical",
      "noPolicyMatchText": "You are trying to download some assets which are not negotiated yet. Or some of the assets that you are trying to negotiate, do not have identical policies. Please select correct assets and continue.",
      "negotiateInProgress": "Negotiation and download in progress",
      "negotiateAndDownloadSuccess": "Negotiation and download completed successfully",
      "negotiateAndTransferSuccess": "Negotiation and transfer completed successfully",
      "transferSuccess": "Transfer completed successfully",
      "progress": "Progress",
      "fetchShell": "Fetch shell",
      "exportToCSV": "Export to CSV",
      "fetchJobFailed": "Error while fetching job details",
      "negotiateError": "Error while downloading assets",
      "dtr": "Digital twin registry",
      "edc": "Connector Assets",
      "browseDtr": "Browse DTR"
    },
    "existingContracts": {
      "heading": "Contracts available",
      "description": "Some extraordinary description gonna come here!"
    },
    "dtr": {
      "title": "Digital twin shells",
      "shells": "Browse shells",
      "description": "You are going to automatically negotiate fetching and exporting Shells from Digital twin registry of the selected provider",
      "noPoliciesFound": "No policies found for this asset",
      "errorFetchingPolicies": "Error fetching policies. Please try again.",
      "negotiate": "Negotiate"
    }
  },
  "assetUploadHistory": {
    "title": "Asset upload history",
    "subtitle": "This history overviews the transactions on your companies's dataspace connectors. All activites on assets, policies and contract definitions are listed here.",
    "refresh": "Refresh",
    "processId": "Process ID",
    "providerUrl": "Provider URL",
    "createdOn": "Created on",
    "totalItems": "Total items",
    "successful": "Successful",
    "failed": "Failed",
    "startDate": "Start Date",
    "endDate": "End Date",
    "howItWork": {
      "title": "How does it work?",
      "description": "You can find the history of all your uploaded assets across different dataspaces.  You can re-download the files locally or transfer them to an external location. In case of errors, you must retry downloading or renegotiate the data offer.",
      "moreInfo": "Want to know more about upload history and what all can you do here?"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "The history provides you the overview of your organization's downloaded data available from the negotiated contracts in the dataspace. If needed, you can download the data again from this history list.",
    "howItWorks": {
      "description": "You can find the history of all your downloaded assets across different dataspaces.  You can re-download the files locally or transfer them to an external location. In case of errors, you must retry downloading or renegotiate the data offer.",
      "moreInfo": "Want to know more about download history and what all can you do here?"
    },
    "downloadError": "Download unsuccessful, Please try again!",
    "viewErrors": "View errors",
    "processId": "Process Id"
  },
  "digitalTwinBrowser": {
    "subHeading": "These are your Digital Twins and their submodels. Your Digital Twins are exposed to the dataspace via your Digital Twin Registry.",
    "noDocumentError": "No aspectDocument for current id",
    "nameNotProvided": "Name not provided",
    "fetchDigitalTwinsError": "Failed to fetch digital twins",
    "fetchAspectDocumentError": "Failed to fetch aspect document",
    "fetchAspectModelError": "Failed to fetch aspect model",
    "detailsOverviewModalTitle": "Aspect Details",
    "addItem": "Add item",
    "detailsTable": {
      "idShort": "ID Short",
      "displayName": "Display Name",
      "modelUrn": "Model URN"
    },
    "shellsTable": {
      "manufacturer": "Manufacturer Part ID",
      "modifiedBy": "User",
      "modifiedAt": "Time"
    }
  },
  "connector": {
    "addNewConnector": "+ Add new connector",
    "searchConnector": "Search by Connector name",
    "connectorModal": {
      "error": "Failed to fetch Connector details"
    }
  },
  "column": {
    "name": "Name",
    "connectorName": "Connector name",
    "contractId": "Contract ID",
    "productId": "Product ID",
    "manufacturerPartId": "Manufacturer Part ID",
    "manufacturerId": "Manufacturer ID",
    "digitalTwinType": "Digital Twin Type",
    "correlationId": "Correlation ID",
    "requestId": "Request ID",
    "bpn": "BPN",
    "createdAt": "Created at",
    "createdBy": "Created by",
    "attribute": "Attribute",
    "value": "Value",
    "url": "URL",
    "actions": "Actions",
    "lastUpdatedTime": "Last updated time",
    "status": "Status",
    "requestedDate": "Requested date",
    "policyType": "Policy type",
    "modifiedBy": "Modified by",
    "modifiedOn": "Modified on",
    "syncStatus": "Sync status",
    "assetId": "Asset ID",
    "assetType": "Asset type",
    "type": "Type",
    "createdFrom": "Created from",
    "createdTo": "Created to",
    "statusDuration": "Status/Duration",
    "certifier": "Certifier",
    "version": "Version",
    "registrationNumber": "Registration No",
    "validUntil": "Valid until",
    "offerId": "Offer ID",
    "errorMessage": "Error message",
    "globalAssetId": "Global Asset ID",
    "shellName": "Shell Name",
    "contractAgreementId": "Contract Agreement ID",
    "signingDate": "Signing Date",
    "providerConnectorUrl": "Provider Connector URL",
    "consumerConnectorUrl": "Consumer Connector URL",
    "providerBpnl": "Provider BPNL",
    "consumerBpnl": "Consumer BPNL",
    "counterPartyId": "Counter Party ID",
    "resourceId": "Resource ID",
    "resourceType": "Resource Type",
    "transactionMethod": "Transaction Method",
    "trustLevel": "Trust Level",
    "intrinsicId": "Intrinsic ID",
    "partId": "Part ID",
    "sentBy": "Sent by",
    "partner": "Partner",
    "sentOn": "Sent on",
    "id": "ID",
    "catenaXId": "Catena-X ID",
    "customerPartId": "Customer Part ID"
  },
  "messagesBrowser": {
    "fetchMessagesError": "Failed to fetch messages",
    "openRelatedMessage": "Open related message",
    "messagesTable": {
      "context": "Context",
      "senderBpn": "Sender BPN",
      "receiverBpn": "Receiver BPN",
      "correlationId": "Correlation ID",
      "jobId": "Job ID",
      "conversationId": "Conversation ID"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "Generic",
      "quality": "Quality",
      "ccmpush": "CCM Push",
      "ccmrequest": "CCM Request",
      "ccmstatus": "CCM Status",
      "ccmavailable": "CCM Available",
      "blockNotification": "Block Notification",
      "dtrEvent": "DTR Event",
      "csm": "CSM"
    }
  },
  "blockNotifications": {
    "title": "Blocking notifications",
    "description": "Welcome to the easy to use end-to-end Blocking Notifications solution in Catena-X",
    "recentNotifications": "Recent notifications",
    "totalAffected": "Total affected parts",
    "top5": "Top 5 Exchange partners",
    "sendNotifications": "Send blocking notifications",
    "sendUpdate": "Send update",
    "editNotification": "Edit notification",
    "updateNotification": "Update notification",
    "sentHistory": "Sent notification history",
    "receivedHistory": "Received notification history",
    "sendDescription": "Create and share your site certificates in Catena-X network",
    "sentHistoryDescription": "Use the area to manage your certificate data requests from partners.",
    "receivedHistoryDescription": "View and manage blocking notifications received from partners.",
    "learnMore": "Learn more about Blocking Notifications",
    "confirmationText": "I understand and confirm that I have correctly filled in all the required information. I also confirm that I understand that by sending this message, I agree to the policies of the message recipient.",
    "validityDisclaimer": "T-Systems does not check the validity of the metadata information filled here. Please ensure that you have filled in correct and complete information.",
    "generalInformation": "General Information",
    "jobName": "Job Name",
    "jobNamePlaceholder": "Enter job name",
    "receiverBpn": "Receiver BPN",
    "expectedResponseBy": "Expected Response By",
    "notificationDetails": "Notification Details",
    "filters": {
      "lastYear": "Last 1 year",
      "sixMonths": "6 months",
      "threeMonths": "3 months",
      "oneMonth": "1 month",
      "lastWeek": "Last week",
      "selectDateRange": "Select date range",
      "bpnOrCompany": "Business partner number or a company name"
    },
    "stats": {
      "totalAffectedParts": "Total affected parts",
      "topExchangePartners": "Top {count} Exchange partners",
      "sentNotifications": "Sent notifications",
      "receivedNotifications": "Received notifications"
    },
    "table": {
      "conversationName": "Conversation name",
      "problemId": "Problem ID",
      "partner": "Partner",
      "partnerName": "Partner Name",
      "createdAt": "Created at",
      "sentBy": "Sender",
      "sentOn": "Sent on",
      "receivedOn": "Received on"
    },
    "errors": {
      "fetchSentNotifications": "Failed to fetch sent notifications",
      "fetchStatistics": "Failed to fetch statistics",
      "fetchRecentNotifications": "Failed to fetch recent notifications",
      "invalidDateRange": "Cannot fetch statistics without valid date range",
      "sendNotificationFailed": "Failed to send block notification. Please try again.",
      "validationFailed": "Please fill all mandatory fields"
    },
    "success": {
      "notificationSent": "Block notification sent successfully",
      "notificationUpdateSent": "Block notification update sent successfully"
    },
    "importJson": {
      "title": "Import JSON File",
      "description": "Upload a JSON file to automatically fill the form with the provided data. The file should match the block notification schema.",
      "importButton": "Import from JSON",
      "dropFileHere": "Drag and drop your JSON file here",
      "selectFile": "Select File",
      "import": "Import",
      "success": "Form data successfully imported from JSON",
      "parseError": "Failed to parse JSON file",
      "readError": "Failed to read the file. Please try again."
    },
    "partPicker": {
      "button": "Part picker",
      "title": "Part Picker",
      "description": "Select digital twins from your provider data to auto-fill block information items.",
      "addToForm": "Add to form",
      "success": "{count} block information item(s) added to the form.",
      "error": "Failed to load aspect details. Please try again."
    },
    "groups": {
      "notificationInformation": "Notification Information",
      "blockInformationItems": "Block Information Items *",
      "partIdentification": "Part Identification",
      "componentLevelContainment": "Component Level Containment",
      "periodAndVolumeLevelContainment": "Period and Volume Level Containment",
      "deliveryInformation": "Delivery Information",
      "quantities": "Quantities",
      "sizeOfProductionLot": "Size of Production Lot",
      "numberOfPartsPerDeliveryNote": "Number of Parts per Delivery Note",
      "numberOfPartsPerPackage": "Number of Parts per Package",
      "locationInContainer": "Location in Container (Optional)"
    },
    "fields": {
      "problemId": "Problem ID",
      "notificationStatus": "Notification Status",
      "problemDescription": "Problem Description",
      "updateReason": "Update Reason",
      "catenaXId": "Catena-X ID",
      "blockStatus": "Block Status",
      "manufacturingLocationId": "Manufacturing Location ID",
      "customerPartId": "Customer Part ID",
      "integrationLevel": "Integration Level",
      "localIdentifiers": "Local Identifiers",
      "key": "Key",
      "value": "Value",
      "orderNumber": "Order Number",
      "deliveryNoteNumber": "Delivery Note Number",
      "packageNumber": "Package Number",
      "deliveryPlace": "Delivery Place",
      "productionDate": "Production Date",
      "deliveryDate": "Delivery Date",
      "quantity": "Quantity",
      "unit": "Unit",
      "xPosition": "X Position",
      "yPosition": "Y Position",
      "smallLoadCarrierLayer": "Small Load Carrier Layer"
    },
    "tooltips": {
      "problemDescription": "A free text field which provides information why the parts must be blocked.",
      "updateReason": "Free text describing why the previously provided list of damaged parts needs to be updated.",
      "catenaXId": "The fully anonymous Catena-X ID of the serialized part or batch.",
      "blockStatus": "Status of the individual part within a blocking notification.",
      "manufacturingLocationId": "Address of the supplier's location from which the components are delivered."
    },
    "howTo": {
      "description": "Discover the data offer catalog of other Catena-X member companies. You can send and receive blocking notifications. ",
      "doc": "Want to know more about how block notifications work?"
    }
  },
  "ecu": {
    "title": "Electronic Control Unit (ECU)",
    "description": "Welcome to the easy to use overview for your ECU data exchange within Catena-X network.",
    "sentHistory": "Sent messages history",
    "receivedHistory": "Received messages history",
    "sentHistoryDescription": "View and manage outgoing ECU messages sent to partners.",
    "receivedHistoryDescription": "View and manage incoming ECU messages received from partners.",
    "tiles": {
      "item_1": {
        "title": "Outgoing messages",
        "description": "View outgoing ECU messages to partners in Catena-X network"
      },
      "item_2": {
        "title": "Incoming messages",
        "description": "Receive incoming messages from ECU partners in Catena-X network"
      },
      "item_3": {
        "title": "ECU User guide",
        "description": "Learn more about ECU use-case and how it works"
      },
      "item_4": {
        "title": "Developer documentation",
        "description": "Quick access to APIs to set up and manage ECU data exchange"
      },
      "item_5": {
        "title": "ECU Assets",
        "description": "View and search for all ECU assets"
      },
      "item_6": {
        "title": "ECU process logs",
        "description": "Access process logs for transparency and incident management"
      }
    },
    "howTo": {
      "description": "Create resilient supply chains using automated status notification and feedback loop for Electronic Control Units within Catena-X network.",
      "doc": "Want to know more about how Electronic Control Unit (ECU) messaging works?"
    },
    "filters": {
      "senderBpn": "Sender BPN",
      "receiverBpn": "Receiver BPN",
      "catenaXId": "Catena-X ID",
      "ecuId": "ECU ID",
      "catenaXSiteId": "Catena-X Site ID"
    },
    "table": {
      "conversationName": "Conversation name",
      "senderBpn": "Sender BPN",
      "receiverBpn": "Receiver BPN",
      "sentOn": "Sent on",
      "receivedOn": "Received on"
    },
    "errors": {
      "fetchNotifications": "Failed to fetch ECU notifications"
    },
    "stats": {
      "total": "Total",
      "messagesPerCountry": "Messages per country",
      "sentMessages": "Sent messages",
      "receivedMessages": "Received messages",
      "technicalSpecifications": "Technical Specifications",
      "connector": "Connector",
      "connectors": "Connectors",
      "policies": "Policies",
      "viewAllConnectors": "View all connectors",
      "viewAllPolicies": "View all policies"
    }
  },
  "qualityAlert": {
    "sendAlert": "Send quality alert",
    "sendInvestigation": "Send quality investigation",
    "sendSuccess": "Sent successfully!",
    "updateAlert": "Update quality alert",
    "updateInvestigation": "Update quality investigation",
    "updateSuccess": "Updated successfully!",
    "acceptConfirmTitle": "Accept Quality Alert",
    "acceptConfirmDesc": "By clicking Yes, you accept this quality alert and agree to take appropriate action.",
    "rejectConfirmTitle": "Reject Quality Alert",
    "rejectConfirmDesc": "By clicking Yes, you reject this quality alert. The sender will be notified of the rejection."
  },
  "traceability": {
    "title": "Traceability",
    "description": "Welcome to the easy to use end-to-end Traceability application for Catena-X data exchange",
    "createQualityAlertOrInvestigation": "Create quality alert or investigation",
    "learnMore": "Learn more about Traceability",
    "recentIndustryCoreNotifications": "Recent industry core notifications",
    "recentTraceabilityNotifications": "Recent traceability notifications",
    "tabs": {
      "inbound": "Inbound",
      "outbound": "Outbound",
      "published": "Published",
      "consumed": "Consumed"
    },
    "howTo": {
      "description": "Discover the data offer catalog of other Catena-X member companies. You can search, select and subscribe to a data offer. You can search for data offers using the company name or with the Manufacturer Part ID or with a combination of two.",
      "doc": "Want to know more about data offer negotiation and consumption work?"
    },
    "tiles": {
      "createOffer": {
        "title": "Create traceability offer",
        "description": "Create and share Traceability data with participants in Catena-X network"
      },
      "discoverData": {
        "title": "Discover traceability data",
        "description": "Search and negotiate Traceability data within Catena-X network"
      },
      "notifications": {
        "title": "Traceability notifications",
        "description": "Quick access to quality notifications such as quality alerts and quality investigations"
      },
      "industryCoreNotifications": {
        "title": "Industry core notifications",
        "description": "View digital twin event notifications such as submodel update, feedback events and more"
      },
      "contractAgreements": {
        "title": "Contract agreements",
        "description": "View all provided and consumed contract agreements"
      },
      "exchangeHistory": {
        "title": "Exchange history",
        "description": "Gain transparency over your traceability data exchange history in the Catena-X network and your partners",
        "uploadHistory": "Upload history",
        "downloadHistory": "Download history"
      },
      "blockNotifications": {
        "title": "Block notifications",
        "description": "Easily and quickly report defects and send block notifications to partners for the affected parts."
      }
    }
  },
  "useCases": {
    "ecu": {
      "title": "Electronic Control Unit",
      "description": "Electronic Control Unit"
    },
    "ecuTest": {
      "title": "Electronic Control Unit (Test)",
      "description": "Electronic Control Unit Messaging. Without constraint to business-partners"
    },
    "co2": {
      "title": "Sustainability (CO2 Footprint)",
      "description": "Sustainability (CO2 Footprint)"
    },
    "dcm": {
      "title": "Demand and Capacity Management",
      "description": "Demand & Capacity Management - fewer bottlenecks, more security"
    },
    "ce": {
      "title": "Circular Economy",
      "description": "Circular Economy - maximum use of resources"
    },
    "companyCertificates": {
      "title": "Business Partner Certificate Management",
      "description": "Streamline the process of managing and exchanging business partner certificates, reducing the burden of maintaining multiple certificates for different customers."
    },
    "cyberSecurityKpi": {
      "title": "Cyber Security Metrics",
      "description": "Streamline the process of managing and exchanging Cyber Security Kpi, reducing the burden of maintaining multiple Cyber Security Kpi for different customers."
    },
    "traceability": {
      "title": "Traceability",
      "description": "Traceability is to trace physical parts and materials across the entire value creation chain to enable data driven use cases over all n-tier levels without compromising data sovereignty."
    },
    "blockingNotifications": {
      "title": "Blocking Notifications",
      "description": "Blocking notifications are used to inform about a blockage in the production process, e.g. due to quality issues. The notifications can be used to trigger further actions, e.g. to start a quality investigation or to inform other business partners about the blockage."
    },
    "batteryPassBmw": {
      "title": "Battery Pass (BMW)",
      "description": "BMW Battery Pass - maximum use of resources in the battery supply chain"
    },
    "modularProduction": {
      "title": "Modular Production",
      "description": "Modular Production"
    },
    "qualityManagement": {
      "title": "Quality Management",
      "description": "Quality Management"
    },
    "realTimeControl": {
      "title": "Real-time Control",
      "description": "Real-time Control"
    }
  }
}
